import { Link } from "react-router-dom";
import { Sparkles, Database, FileCheck2, AlertCircle } from "lucide-react";
import { Markdown } from "@/components/toth/Markdown";
import { cn } from "@/lib/utils";

const LABEL = {
  panoramica: "Panoramica operativa", cerca_ordini: "Ricerca ordini", dettaglio_ordine: "Dettaglio ordine", cerca_criticita: "Ricerca criticità",
  cerca_mezzi: "Mezzi e attrezzature", scadenze: "Scadenze", elenco_persone: "Personale", proponi_sollecito: "Proposta di sollecito",
  proponi_modifica_scadenza: "Proposta nuova scadenza", proponi_riassegnazione: "Proposta di riassegnazione", proponi_ordine: "Proposta nuovo ordine",
};

export const ChatMessage = ({ m, idx, streaming }) => {
  if (m.role === "user") {
    return (
      <div className="flex justify-end" data-testid={`toth-msg-user-${idx}`}>
        <div className="max-w-[85%] whitespace-pre-wrap rounded-2xl rounded-br-md bg-primary px-4 py-2.5 text-sm text-primary-foreground">{m.content}</div>
      </div>
    );
  }
  const tools = [...new Set(m.tools || [])];
  return (
    <div className="flex gap-2" data-testid={`toth-msg-assistant-${idx}`}>
      <div className="mt-1 flex h-7 w-7 shrink-0 items-center justify-center rounded-full brand-gradient text-white"><Sparkles className="h-3.5 w-3.5" /></div>
      <div className="min-w-0 flex-1 space-y-2">
        {tools.length > 0 && (
          <div className="flex flex-wrap gap-1.5">
            {tools.map((t) => <span key={t} className="inline-flex items-center gap-1 rounded-full bg-muted px-2 py-0.5 text-[11px] font-semibold text-muted-foreground"><Database className="h-3 w-3" />{LABEL[t] || t}</span>)}
          </div>
        )}
        <div className={cn("rounded-2xl rounded-tl-md border bg-white px-4 py-3", streaming && !m.content && "animate-pulse")}>
          {m.content ? <Markdown text={m.content} testid={`toth-msg-text-${idx}`} /> : <p className="text-sm text-muted-foreground">{streaming ? "Toth sta consultando i dati…" : "—"}</p>}
        </div>
        {(m.proposals || []).map((p) => (
          <Link key={p.id} to="/toth?tab=proposals" className="flex items-center gap-2 rounded-xl border border-amber-300 bg-amber-50 px-3 py-2 text-sm font-semibold text-amber-900" data-testid={`toth-msg-proposal-${p.id}`}>
            <FileCheck2 className="h-4 w-4 shrink-0" /> Proposta creata, da approvare: {p.title}
          </Link>
        ))}
        {m.error && <p className="flex items-center gap-1 text-sm font-semibold text-red-600" data-testid={`toth-msg-error-${idx}`}><AlertCircle className="h-4 w-4" />{m.error}</p>}
      </div>
    </div>
  );
};
